//=require _jquery.cubeportfolio.min.js

var filter = $.urlParam('filter');

$(document).ready(function() {
    $('#js-grid-masonry').cubeportfolio({
        filters: '#js-filters-masonry',
        layoutMode: 'grid',
        defaultFilter: filter ? '.' + filter : '*',
        //filterDeeplinking: true,
        animationType: 'slideDelay',
        gapHorizontal: 20,
        gapVertical: 20,
        gridAdjustment: 'responsive',
        mediaQueries: [{
            width: 1024,
            cols: 3,
        }, {
            width: 480,
            cols: 2
        }, {
            width: 360,
            cols: 1
        }],
        caption: '',
        displayType: 'bottomToTop',
        displayTypeSpeed: 100,

        // lightbox
        lightboxDelegate: '.cbp-lightbox',
        lightboxGallery: true,
        lightboxTitleSrc: 'data-title',
        lightboxCounter: '<div class="cbp-popup-lightbox-counter">{{current}} of {{total}}</div>',
    });
});
